function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// prompt にお手本テキストを渡すと Whisper がそちらに引っ張られて認識精度が上がる
export async function transcribeAudio(audioBlob, prompt = '') {
  try {
    const base64 = await blobToBase64(audioBlob);

    const res = await fetch('/api/transcribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // promptは150文字に制限（長すぎると読んでいない部分をWhisperが補完してしまう）
      body: JSON.stringify({ audio: base64, mimeType: audioBlob.type, prompt: prompt.slice(0, 150) }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: `HTTP ${res.status}` }));
      throw new Error(err.error || `Transcribe error: ${res.status}`);
    }

    const data = await res.json();
    // Whisper が認識できなかった部分に U+FFFD（◆）や記号が混入することがある → 除去
    return (data.text?.trim() ?? '').replace(/[�■-◿]/g, '');
  } catch (e) {
    // ローカル開発（npm start）ではAPIルートが存在しないのでモックを返す
    if (e.message.includes('404') || e.message.includes('Failed to fetch')) {
      console.warn('API route unavailable, using mock transcript');
      return getMockTranscript();
    }
    throw e;
  }
}

function getMockTranscript() {
  const samples = [
    'ひろい　うみの　どこかに',
    'ちいさな　さかなたちの　きょうだいが　いた',
    'みんな　あかい　のに',
  ];
  return samples[Math.floor(Math.random() * samples.length)];
}
